import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Mails, Loader2, Clock, Paperclip } from "lucide-react";
import { avatarFor, stripHtml, fmtDate } from "./inboxUtils";

export const ThreadDialog = ({ open, onOpenChange, title, loading, msgs, catStyle, catLabel, onOpenMessage }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="thread-dialog" className="max-w-3xl max-h-[85vh] overflow-hidden flex flex-col">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2 text-lg pr-6">
          <Mails className="h-5 w-5 text-[#007BFF]" />
          <span className="truncate">{title}</span>
          {!loading && <span className="text-xs font-normal text-gray-400 shrink-0">{msgs.length} messaggi</span>}
        </DialogTitle>
        <DialogDescription className="sr-only">Tutti i messaggi della conversazione.</DialogDescription>
      </DialogHeader>
      <div className="overflow-y-auto scroll-thin -mx-1 px-1 space-y-3">
        {loading && (
          <div className="py-10 flex items-center justify-center text-gray-400 text-sm gap-2">
            <Loader2 className="h-4 w-4 animate-spin" />Carico la conversazione…
          </div>
        )}
        {!loading && msgs.map((m, mi) => {
          const nm = m.sender_name || m.sender || "?";
          const { initial, color } = avatarFor(nm);
          const text = m.body || stripHtml(m.body_html) || "(nessun contenuto testuale)";
          return (
            <div key={m.id} data-testid={`thread-msg-${mi}`} className="border border-gray-200 rounded-lg overflow-hidden">
              <div className="flex items-center gap-3 px-4 py-2.5 bg-gray-50 border-b border-gray-100">
                <div className="h-7 w-7 rounded-md flex items-center justify-center text-white font-bold text-xs shrink-0" style={{ backgroundColor: color }}>{initial}</div>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-semibold text-gray-900 truncate flex items-center gap-1.5">
                    {nm}
                    {m.thread_position && m.thread_received_total > 1 && (
                      <span data-testid={`thread-msg-pos-${mi}`} title={`Risposta ${m.thread_position} di ${m.thread_received_total}`}
                        className="inline-flex items-center justify-center min-w-[16px] h-[16px] px-1 rounded-full bg-[#007BFF] text-white text-[9px] font-bold shrink-0">
                        {m.thread_position}
                      </span>
                    )}
                  </div>
                  {m.recipient && <div className="text-[11px] text-gray-400 truncate">A: {m.recipient}</div>}
                </div>
                <span className={`text-[9px] font-semibold px-1.5 py-0.5 rounded border shrink-0 ${catStyle(m.category)}`}>{catLabel(m.category) || m.category}</span>
                <div className="text-[11px] text-gray-400 flex items-center gap-1 shrink-0"><Clock className="h-3 w-3" />{fmtDate(m.email_date || m.created_at)}</div>
              </div>
              <p className="text-sm whitespace-pre-wrap leading-relaxed text-gray-800 px-4 py-3 max-h-64 overflow-y-auto scroll-thin">{text}</p>
              <div className="px-4 pb-3 flex items-center gap-3">
                {m.has_attachments && <span className="text-[11px] text-gray-400 flex items-center gap-1"><Paperclip className="h-3 w-3" />allegati</span>}
                <button data-testid={`thread-open-${mi}`} onClick={() => onOpenMessage(m)}
                  className="text-[11px] text-[#007BFF] hover:underline ml-auto">Apri messaggio →</button>
              </div>
            </div>
          );
        })}
      </div>
    </DialogContent>
  </Dialog>
);
